<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="info"
    title="FAQ - Парсинг чатов"
    (close)="senderService.isOpenedAddBalance = true"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>
      <img class="w-100" src="/assets/images/faq/parse/post.svg" alt="">

      <!--<div class="text-center">
        <img class="w-75" src="/assets/images/faq/parse/step-1.jpg" alt="">
      </div>
      <img class="w-100" src="/assets/images/faq/parse/step-2.jpg" alt="">
      <img class="w-100" src="/assets/images/faq/parse/step-3.jpg" alt="">
      <img class="w-100" src="/assets/images/faq/parse/step-4.jpg" alt="">
      <img class="w-100" src="/assets/images/faq/parse/step-5.jpg" alt="">-->
    </div>
  </div>
</div>
